import { RankingItem } from '@pages/Portal/Competitions/components/RankingTable/interfaces';
import { PortalRankingEntry } from '@api/competitionsApi/interfaces';
import { ROUTES } from '@routes/routes';

export const mapRankingEntryToRankingItem = (
  entry: PortalRankingEntry
): RankingItem => ({
  id: entry.member.slug,
  rank: entry.rank,
  name: entry.member.fullName,
  avatarSource: ROUTES.images.avatar(entry.member.slug),
  weaponGroups: entry.weaponGroups ?? [],
  totalSubmitted: entry.submissionCount,
  totalScore: entry.rankingScore,
  positionChange: entry.positionChange,
  previousRank: entry.previousRank,
});
